// extracted by mini-css-extract-plugin
module.exports = {"mid-term-feature-container":"MidTermFeature_mid-term-feature-container__2yxXT","filter-item-container":"MidTermFeature_filter-item-container__dVGHP"};